import { theme } from '@qr-front/ui'

export type TQrColorScheme = {
	name: string
	primary: string
	secondary: string
}

export const qrColorSchemeList = [
	{
		name: 'color-scheme-1',
		primary: theme.colors['qr-color-scheme-1'].primary,
		secondary: theme.colors['qr-color-scheme-1'].secondary,
	},
	{
		name: 'color-scheme-2',
		primary: theme.colors['qr-color-scheme-2'].primary,
		secondary: theme.colors['qr-color-scheme-2'].secondary,
	},
	{
		name: 'color-scheme-3',
		primary: theme.colors['qr-color-scheme-3'].primary,
		secondary: theme.colors['qr-color-scheme-3'].secondary,
	},
	{
		name: 'color-scheme-4',
		primary: theme.colors['qr-color-scheme-4'].primary,
		secondary: theme.colors['qr-color-scheme-4'].secondary,
	},
	{
		name: 'color-scheme-5',
		primary: theme.colors['qr-color-scheme-5'].primary,
		secondary: theme.colors['qr-color-scheme-5'].secondary,
	},
	{
		name: 'color-scheme-6',
		primary: theme.colors['qr-color-scheme-6'].primary,
		secondary: theme.colors['qr-color-scheme-6'].secondary,
	},
	{
		name: 'color-scheme-7',
		primary: theme.colors['qr-color-scheme-7'].primary,
		secondary: theme.colors['qr-color-scheme-7'].secondary,
	},
] as const satisfies TQrColorScheme[]
